export default __webpack_public_path__ + "static/media/Melting-Temperatures_A1.4b0d1e5d.pdf";